import { render, staticRenderFns } from "./replace-manual.vue?vue&type=template&id=5f5468d6&scoped=true"
import script from "./replace-manual.vue?vue&type=script&lang=ts"
export * from "./replace-manual.vue?vue&type=script&lang=ts"
import style0 from "./replace-manual.vue?vue&type=style&index=0&id=5f5468d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5468d6",
  null
  
)

export default component.exports